import {FormArray} from '@angular/forms';

export function formArrayItemsLengthValidator() {
  return (formArray: FormArray) => {
    if (!formArray.parent || !formArray || !formArray.controls) {
      return null;
    }

    const {controls} = formArray;

    const values = controls.map(control => control.value);

    const truthyValues = values.filter(value => !!value);

    if (truthyValues.length === 0) {
      return {atLeastOneItemRequired: true};
    }

    return null;
  };
}
